import React from 'react'
import PropTypes from 'prop-types'
import Media from 'components/common/Media'
import FilterBreadcrumbs from 'components/common/Filters/FilterBreadcrumbs'

const BOTGlobalSearchBreadcrumbs = ({
  applyFilter,
  mappedRefinementCrumbs,
  resetFilters,
  clearAllNavigationState
}) =>
  <Media.Desktop>
    <FilterBreadcrumbs
      clearAllNavigationState={ clearAllNavigationState }
      selectedFilters={ mappedRefinementCrumbs }
      onFilterClear={ resetFilters }
      onFilterRemove={ applyFilter } />
  </Media.Desktop>

export default BOTGlobalSearchBreadcrumbs

BOTGlobalSearchBreadcrumbs.propTypes = {
  applyFilter: PropTypes.func,
  clearAllNavigationState: PropTypes.string,
  mappedRefinementCrumbs: PropTypes.arrayOf(PropTypes.shape()),
  resetFilters: PropTypes.func
}
